module.exports = __webpack_public_path__ + "media/images/balance-product-cloud-91c9374892692bdc6e475432075d3b02.png";